/* Copyright 2013 - 2024 Waiterio LLC */
import { toast } from '../services/Toaster.js'

export default ({ error } = {}) => {
  if (error && error.length > 0) {
    toast(error)
  }
}
